<template>
    <div id="navbar-fixed" class="navbar navbar-bottom navbar-fixed flexBox" ref="navigation">
        <router-link class="navbar-item flexBox" v-for="(navs, index) in navbarList" :key="index" :to="{name:navs.route}" :class="{'navbar-item-active': barActive === navs.route}">
            <i class="msg-count" v-if="navs.route === 'message' && msgCount && msgCount > 0">{{ msgCount > 99 ? '99+' : msgCount }}</i>
            <i class="navbar-image" :class="navs.route"></i>
            <span class="navbar-name" v-text="navs.name"></span>
        </router-link>
    </div>
</template>

<script>

    import {  COMMENTS } from '../api'
    export default {
        name: 'navigation',
        data () {
            return {
                msgCount : null,
                intialHeight: window.innerHeight || document.documentElement.clientHeight,
                navbarList:[
                    {
                        name: '首页',
                        route: 'home'
                    },
                    {
                        name: '收藏',
                        route: 'favorites'
                    },
                    {
                        name: '消息',
                        route: 'message'
                    },
                    {
                        name: '我的',
                        route: 'mine'
                    },
                ]
            }
        },
        mounted () {
            this.getUnReadMsgTotal()
        },
        methods: {
            getUnReadMsgTotal(){
                COMMENTS.GetMsgTotal().then((res)=>{
                    this.msgCount = res.Data.TotalCount
                })
            },
            // resizeHandler () {
            //     let currHeight = window.innerHeight || document.documentElement.clientHeight
            //     if(currHeight < this.intialHeight) {  // 键盘弹起
            //         this.$refs.navigation.style.bottom = '-100px'
            //     } else {  // 键盘收起
            //         this.$refs.navigation.style.bottom = '0'
            //     }
            // }
        },
        computed: {
            barActive () {
                return this.$route.name
            },
        },
        watch: {
            '$route' (to, from) {
                if(to.name == 'message') {
                    this.msgCount = 0
                }else if(from.name != ''){
                    this.getUnReadMsgTotal();
                }
            }
        },
        destroyed () {
            // window.removeEventListener('resize', this.resizeHandler)
        }
    }
</script>

<style lang="scss" scoped>
    .navbar-fixed {
        position: fixed;
        z-index: 1100;
        left: 0; right: 0;
        bottom: 0;
        height: j(98);
        background: #fff;
        justify-content: space-between;
        opacity:1;
        // @include iphoneX () {
        //     border-bottom: 34px solid #fff;
        // }
        &:after {
            @include thin-bt(#f0f1f2);
        }
        .navbar-item {
            height: 100%;
            font-size: 0;
            flex: 1;
            flex-direction: column;
            justify-content: center;
            position: relative;
            .navbar-name {
                font-size: j(24);
                color: #9b9da9;
                display: block;
            }
            .navbar-image {
                width: j(48);
                height: j(48);
                background-repeat: no-repeat;
                background-size: contain;
                background-position: center;
                &.home {
                    background-image: url('/static/images/navs/home.png');
                }
                &.favorites {
                    background-image: url('/static/images/navs/favorites.png');
                }
                &.message {
                    background-image: url('/static/images/navs/message.png');
                }
                &.follow {
                    background-image: url('/static/images/navs/follow.png');
                }
                &.history {
                    background-image: url('/static/images/navs/history.png');
                    width: j(40);
                    height: j(40);
                }
                &.mine {
                    background-image: url('/static/images/navs/mine.png');
                    width: j(46);
                    height: j(46);
                }
            }
            .msg-count {
                position: absolute;
                font-style: normal;
                top: j(10);
                left: 56%;
                height: j(24);
                border-radius: j(24);
                line-height: 1;
                padding:j(2) j(10);
                background-color: #EF7575;
                color: #ffffff;
                font-size: j(20);
                display: flex;
                align-items: center;
            }
        }
        .navbar-item-active  {
            .navbar-name {
                color: #363c54;
            }
            .navbar-image {
                &.home {
                    background-image: url('/static/images/navs/home-active.png');
                }
                &.favorites {
                    background-image: url('/static/images/navs/favorites-active.png');
                }
                &.message {
                    background-image: url('/static/images/navs/message-active.png');
                }
                &.follow {
                    background-image: url('/static/images/navs/follow-active.png');
                }
                &.history {
                    background-image: url('/static/images/navs/history-active.png');
                }
                &.mine {
                    background-image: url('/static/images/navs/mine-active.png');
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/navigation.vue